<template>
  <div :class="wrapperClasses" v-if="info">
    <router-view />
    <Header />
    <div class="flashwrap">
      <img
        alt="image"
        v-if="$route.name === 'Main' && !isExchange && !isMobileFlash"
        :class="flashClasses"
        src="@/assets/img/flash-main.webp"
      />
      <img
        alt="image"
        v-if="$route.name === 'Partners'"
        :class="flashClasses"
        src="@/assets/img/kenty.webp"
      />
      <div
        v-if="$route.name === 'Main' && !isExchange && !isMobile"
        class="flashcom"
      >
        СКОРОСТНОЙ, БЕЗОПАСНЫЙ <br />
        И КОНФИДЕНЦИАЛЬНЫЙ <br />ОБМЕН КРИПТОВАЛЮТ
      </div>
    </div>

    <Footer />

    <Modals />

    <Sidebar />

    <!-- <Chat /> -->
  </div>
</template>

<script>
import "@/assets/css/style.css";
import Header from "@/components/ui/Header";
import Footer from "@/components/ui/Footer";
import Modals from "@/components/ui/Modals";
import Sidebar from "@/components/ui/Sidebar";

import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "App",
  components: { Header, Footer, Modals, Sidebar },
  created() {
    if (
      window.location.hostname != "localhost" &&
      window.location.hostname != "127.0.0.1" &&
      window.location.protocol !== "https:"
    ) {
      window.location.replace(
        `https:${window.location.href.substring(
          window.location.protocol.length
        )}`
      );
    }
  },
  mounted() {
    const storageAuth = localStorage.getItem("Auth");
    if (storageAuth) {
      const auth = JSON.parse(storageAuth);
      this.set(auth);
    }
    const referal = this.getCookie("referal");
    if (referal) {
      this.setReferal(referal);
    }
    this.getInfo();
  },
  methods: {
    ...mapActions("info", ["getInfo"]),
    ...mapMutations("auth", ["set"]),
    ...mapMutations(["setReferal"]),
    ...mapActions("valutes", ["setIsExchange"]),
    getCookie(name) {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    updateWrapperClasses(route) {
      if (route.name !== "Main") {
        this.setIsExchange(false);
      }
    }
  },
  computed: {
    ...mapState("info", ["info"]),
    ...mapState(["currentPage"]),
    ...mapState("modals", ["sidebar", "dropdownGive", "dropdownGet"]),
    ...mapState("modals", ["modals"]),
    ...mapState("valutes", ["isExchange"]),
    wrapperClasses() {
      if (this.isExchange) {
        return ["main-wrapper", "main-wrapper-Exchange"];
      } else if (
        this.sidebar === true ||
        this.modals.length >= 1 ||
        this.dropdownGive === true ||
        this.dropdownGet === true
      ) {
        return ["main-wrapper", "main-wrapper-Modal"];
      } else {
        return ["main-wrapper", `main-wrapper-${this.$route.name}`];
      }
    },
    flashClasses() {
      if (!this.isExchange) {
        return [`flash-${this.$route.name}`];
      }
    },
    isMobile() {
      if (window.screen.width < 1024) {
        return true;
      } else {
        false;
      }
    }
  },
  watch: {
    $route(to) {
      this.updateWrapperClasses(to);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.updateWrapperClasses(to);
    next();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/App.vue